import { render } from "./lowSales.vue?vue&type=template&id=d3ec1de6&scoped=true"
import script from "./lowSales.vue?vue&type=script&lang=js"
export * from "./lowSales.vue?vue&type=script&lang=js"

import "./lowSales.vue?vue&type=style&index=0&id=d3ec1de6&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3ec1de6"]])

export default __exports__